




















































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { Prop } from 'vue-property-decorator'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'

@Component({
  components: { BaseButton, Modal, CurrencyInput }
})
export default class DiscountChangeDialog extends Vue {
  @Prop({ required: true }) useCase!: BaseRequestLoadingHandler
  @Prop({ required: true }) id!: number[] | number
  @Prop({ default: 0 }) amount: number
  private dialogModel: boolean = false
  private discountAmount = null

  onSubmit(evt) {
    if (this.useCase !== null)
      this.useCase.execute(this.id, this.discountAmount).then(() => {
        if (this.useCase.isSuccess) this.dialogModel = false
      })
    else
      this.dialogModel = false
  }

  onOpen() {
    this.dialogModel = true
    this.discountAmount = this.amount
  }

}
